import { refreshAccessToken, RefreshResult } from "./refreshTokenApi";

// ─── Single-flight Refresh Lock ─────────────────────────────────────────────
// Module-level promise that holds the in-flight refresh, if any. Every caller
// that wants a fresh access token — the 401/403 axios interceptor, the
// route-change hook, page-reload bootstrap — funnels through
// `getOrCreateRefresh` so concurrent callers share a single network round-trip
// instead of stampeding the refresh endpoint.

let inFlightRefresh: Promise<RefreshResult> | null = null;

/**
 * Returns the in-flight refresh promise if one exists, otherwise starts a
 * fresh refresh and caches the promise until it settles. Callers receive the
 * same promise, so a navigation-triggered refresh and an interceptor-triggered
 * refresh racing against each other collapse into one HTTP call.
 */
export const getOrCreateRefresh = (): Promise<RefreshResult> => {
  if (inFlightRefresh) return inFlightRefresh;

  inFlightRefresh = refreshAccessToken().finally(() => {
    inFlightRefresh = null;
  });

  return inFlightRefresh;
};

/** Diagnostic helper — true while a refresh is in progress. */
export const isRefreshInFlight = (): boolean => inFlightRefresh !== null;
